import { render, staticRenderFns } from "./System.vue?vue&type=template&id=75a98980&scoped=true&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"
import style0 from "./System.vue?vue&type=style&index=0&id=75a98980&lang=scss&scoped=true&"
import style1 from "../../sass/components/continue-section.css?vue&type=style&index=1&id=75a98980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a98980",
  null
  
)

export default component.exports